

































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import OrganizationUsersApi from "@/services/OrganizationUsers";
// TODO:達成度(%)の計算で使用
// import UsersApi from "@/services/UsersApi";
// import MaterialGroupApi from "@/services/MaterialGroups";
import { OrganizationUser } from "@/api/lab-base-api-client";
import dayjs from "dayjs";
import CheckOrganizationAdminsLogin from "@/utils/CheckOrganizationAdminLogin";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class OUserListDetail extends CheckOrganizationAdminsLogin {
  private organizationUser: OrganizationUser = {
    uuid: "",
    name: "",
    email: "",
    userDetailUuid: "",
    cusId: "",
    roleId: 0,
    organizationUuid: "",
    ugcUuid: "",
    lastLoginAt: "",
    createdAt: "",
    updatedAt: "",
    deleted: false,
    registered: false,
    paidFlag: false,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    userDetail: undefined!,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    role: undefined!,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ugc: undefined!,
  };

  // 教材の完了パーセンテージ
  private percentage = 0;

  private organizationUserInfo = { updatedAt: { day: "", ago: "" }, register: { day: "", ago: "" } };

  // ページ読み込み時に実行
  private async mounted() {
    await this.fetchList();
    // await this.calcPercentage();
  }

  // ユーザー情報の取得
  private async fetchList() {
    const organizationUserRes = await OrganizationUsersApi.instance.getOrganizationUserByUuid(this.$route.params.uuid);
    this.organizationUser = organizationUserRes.data.data.organizationUser;

    // アカウント登録日
    this.organizationUserInfo.register.day = dayjs(this.organizationUser.createdAt).format("YYYY/MM/DD");
    // 最終ログイン日
    this.organizationUserInfo.updatedAt.day = dayjs(this.organizationUser.lastLoginAt).format("YYYY/MM/DD");
  }

  // TODO:達成度(%)の計算
  // private async calcPercentage() {
  //   const materialGroupsRes = await MaterialGroupApi.instance.getMaterialGroup();
  //   const materialGroups = materialGroupsRes.data.data.items;
  //   const userDetailMaterialGroups = await UsersApi.instance.getCompleteMaterialGroupByUserDetailUuid(
  //     this.organizationUser?.userDetailUuid
  //   );
  //   this.percentage = Math.floor(
  //     (userDetailMaterialGroups.data.data.completeMaterialGroup.items.length / materialGroups.length) * 100
  //   );
  // }
}
